import React from "react";
import Footer from "./Footer";

function TermsConditions() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* ===== MAIN CONTENT ===== */}
      <div style={{ flex: 1, padding: "40px", maxWidth: "900px", margin: "auto" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
          Terms & Conditions
        </h1>

        <p>
          Welcome to <b>KingShop</b>. By using our website, you agree to follow
          these Terms & Conditions. Please read them carefully before making any
          purchase.
        </p>

        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing or using KingShop, you confirm that you accept these
          terms and agree to comply with them.
        </p>

        <h3>2. User Account</h3>
        <p>
          You are responsible for maintaining the confidentiality of your
          account and password. Any activity under your account is your
          responsibility.
        </p>

        <h3>3. Product Information</h3>
        <p>
          We try to provide accurate product details. However, prices,
          availability, and descriptions may change without prior notice.
        </p>

        <h3>4. Orders & Payments</h3>
        <p>
          All orders are subject to acceptance and availability. Payments must
          be completed before order confirmation.
        </p>

        <h3>5. Shipping & Delivery</h3>
        <p>
          Delivery timelines may vary depending on location and courier
          services. Delays caused by external factors are not our responsibility.
        </p>

        <h3>6. Cancellation & Refund</h3>
        <p>
          Orders can be cancelled as per our cancellation policy. Refunds will
          be processed within the applicable time period.
        </p>

        <h3>7. Intellectual Property</h3>
        <p>
          All content, logos, images, and designs on KingShoppy are our property
          and may not be used without permission.
        </p>

        <h3>8. Limitation of Liability</h3>
        <p>
          KingShoppy is not liable for any indirect or incidental damages arising
          from the use of our services.
        </p>

        <h3>9. Changes to Terms</h3>
        <p>
          We reserve the right to update or modify these terms at any time.
          Continued use of the website means you accept the updated terms.
        </p>

        <h3>10. Contact Us</h3>
        <p>
          If you have any questions regarding these Terms & Conditions, please
          contact us through the Contact Us page.
        </p>

        <p style={{ marginTop: "30px", fontWeight: "bold" }}>
          Last Updated: {new Date().toLocaleDateString()}
        </p>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}

export default TermsConditions;
